export enum AlignmentTypes {
    left = 'left',
    center = 'center',
    right = 'right'
}
